<script setup lang="ts">
import { computed } from 'vue';

import LoadingSpinner from '@/components/utilities/LoadingSpinner.vue';

const props = defineProps<{
  label: string;
  pending?: boolean;
  variant?: 'primary' | 'secondary' | 'dark';
  disabled?: boolean;
}>();

const buttonClass = computed(() => {
  const baseClass = 'btn';
  const classes = [baseClass, { 'is-pending': props.pending }];
  if(props.variant) {
    classes.push(`btn_${props.variant}`);
  }
  return classes;
});

const isDisabled = computed(() => {
  return props.disabled || props.pending;
});
</script>

<template>
  <button class="buttonWithLoader"
          :class="buttonClass" 
          :disabled="isDisabled">
    <div 
      class="buttonWithLoader-inner">
      <LoadingSpinner v-if="pending"
                      class="buttonWithLoader-icon" />
      <span>{{ label }}</span>
    </div>
  </button>
</template>

<style lang="scss">
.buttonWithLoader {
  &-inner {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
  }

  &-icon {
    padding: 0;

    .spinner {
      height: 1em;
      width: 1em;

      &::before {
        mask: radial-gradient(transparent 50%, black 60%);
      }
    }
  }

}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
</style>
